import React from "react";

/** Pulse placeholder while org care sector / participant labels are loading. */
const CareLabelSkeleton = ({
  width = "w-24",
  height = "h-4",
  className = "bg-gray-200",
}) => (
  <span
    className={`inline-block ${height} ${width} rounded animate-pulse ${className}`}
    aria-hidden="true"
  />
);

export default CareLabelSkeleton;
